import { zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';
import * as zxcvbnNlBePackage from '@zxcvbn-ts/language-nl-be';
import { matcherPwnedFactory } from '@zxcvbn-ts/matcher-pwned';
import type { Plugin } from 'vue';

const ZxcvbnPlugin: Plugin = {
    install() {
        const matcherPwned = matcherPwnedFactory(fetch, zxcvbnOptions);
        zxcvbnOptions.addMatcher('pwned', matcherPwned);

        const options = {
            dictionary: {
                ...zxcvbnCommonPackage.dictionary,
                ...zxcvbnEnPackage.dictionary,
                ...zxcvbnNlBePackage.dictionary
            },
            graphs: zxcvbnCommonPackage.adjacencyGraphs,
            useLevenshteinDistance: true
        };
        zxcvbnOptions.setOptions(options);
    }
};

export default ZxcvbnPlugin;
